import { Injectable } from '@angular/core';

import { finalize } from 'rxjs/operators';

import { AlertService } from '@core/services/alert/alert.service';
import { LoadingService } from '@core/services/loading/loading.service';
import { PrintDocumentService } from '@core/services/print/print-document.service';
import { FileUtilService } from '@core/services/utils/file-util.service';

import { BaseProductCommand } from '@shared/commands/base-product.command';
import { IProductCommandContext } from '@shared/models/command';
import { ProductTypes } from '@shared/models/products.model';
import { CommandAvailabilityService } from '@shared/services/command-availability.service';

@Injectable({ providedIn: 'root' })
export class DepositAgreementCommand extends BaseProductCommand {
  readonly type = 'deposit-agreement';
  readonly title = 'Договор вклада в формате PDF';
  readonly icon = 'list';
  readonly productType = ProductTypes.DEPOSIT;
  readonly isInfoAction = true;
  readonly settingsNames = undefined;

  get order(): number {
    return this.getContextualOrder(
      {
        [ProductTypes.DEPOSIT]: 40 // Вклад: Договор вклада в формате PDF (4-й в списке "прочее")
      },
      999
    );
  }

  constructor(
    commandAvailabilityService: CommandAvailabilityService,
    private fileUtilService: FileUtilService,
    private loadingService: LoadingService,
    private alertService: AlertService,
    private printDocumentService: PrintDocumentService
  ) {
    super(commandAvailabilityService);
  }

  async execute(context: IProductCommandContext): Promise<void> {
    this.loadingService.showLoader(true);
    this.printDocumentService
      .getPrintDepositDocument(context.data.parentContractId)
      .pipe(finalize(() => this.loadingService.showLoader(false)))
      .subscribe(
        (res) => {
          this.fileUtilService.extractAttachment(
            res,
            `deposit-agreement-${context.data.contractId}.pdf`,
            'application/pdf'
          );
        },
        () => {
          this.alertService.showErrorAlert('Документ не найден, обратитесь в отделение банка');
        }
      );
  }
}
